import { createStyles } from '@material-ui/core/styles'

import type { Theme } from '@material-ui/core/styles'

export const uploadStyles = (theme: Theme) =>
  createStyles({
    document: {
      backgroundColor: theme.customColors.box,
      padding: 30,
    },
  })
